import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";

const LOGO = "/sito/img/logo.png";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/servizi", label: "I Nostri Servizi" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/lavora-con-noi", label: "Lavora con noi" },
  { to: "/contatti", label: "Contatti" },
];

export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`site-header${scrolled ? " scrolled" : ""}`} data-testid="site-header">
      <div className="container header-inner">
        <Link to="/" data-testid="logo-home-link"><img src={LOGO} className="logo-img" alt="POWERCOM" /></Link>
        <nav className={`nav${open ? " open" : ""}`}>
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? "active" : "")}
              data-testid={`nav-${l.to === "/" ? "home" : l.to.slice(1)}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          className={`menu-toggle${open ? " open" : ""}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
          data-testid="menu-toggle"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
